import { render, staticRenderFns } from "./OrderStatusTag.vue?vue&type=template&id=ccbb2f98&scoped=true"
import script from "./OrderStatusTag.vue?vue&type=script&lang=js"
export * from "./OrderStatusTag.vue?vue&type=script&lang=js"
import style0 from "./OrderStatusTag.vue?vue&type=style&index=0&id=ccbb2f98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbb2f98",
  null
  
)

export default component.exports